import { defineMessages } from 'react-intl';

export default defineMessages({
    withdrawalFee: {
        id: '_.draw_down.choose_amount.withdrawal_fee',
        defaultMessage: 'Withdrawal fee'
    },
    always: {
        id: '_.draw_down.choose_amount.always',
        defaultMessage: 'always'
    }
});
